<template>
  <div :style="{ height: '100%', overflow: 'hidden', width: '100%' }">
    <div
      :class="{ 'intro-container': true, 'is-mobile-browser': isMobile && !isIOSApp }"
      :style="{ 'background-image': backgroundImage }"
    >
      <h1 v-if="!isPlayingAnimation" class="activity-title" transition="fade">
        Assessment Accelerator
      </h1>
      <portal v-if="!isPlayingAnimation" to="next-activity-button">
        <next-activity-button :on-click="handleOnClick"></next-activity-button>
      </portal>
      <video
        v-show="isPlayingAnimation"
        id="animation-video"
        playsinline
        ref="assessmentAcceleratorAnimationVideo"
      >
        <source :src="videoSrc" />
      </video>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import NextActivityButton from 'components/activity/NextActivityButton.vue';
import AssessmentAcceleratorIntroImg from 'images/assessment-accelerator-intro.png';
import AssessmentAcceleratorIntroVideo from 'videos/assessment-accelerator-intro.mp4';
import AssetLoader from 'mixins/AssetLoader';

export default {
  props: {
    onComplete: {
      type: Function,
      default: () => {}
    },
    isAssessmentAcceleratorPreview: Boolean
  },

  components: { NextActivityButton },
  computed: {
    ...mapGetters('activity', ['activityTitle']),
    ...mapState('application', {
      isMobile: state => state.device.isMobile,
      isIOSApp: state => state.device.isIOSApp
    }),
    ...mapState('activity', {
      hasScheduledActivity: state => Boolean(state.data.scheduledActivityId)
    })
  },
  data() {
    return {
      backgroundImage: `url(${AssessmentAcceleratorIntroImg})`,
      isPlayingAnimation: false,
      videoSrc: AssessmentAcceleratorIntroVideo
    };
  },
  methods: {
    ...mapMutations('application', ['setToolbarMode']),
    handleOnClick() {
      if (this.isAssessmentAcceleratorPreview) {
        this.onComplete();
        return;
      }
      this.isPlayingAnimation = true;

      this.videoRef = this.$refs.assessmentAcceleratorAnimationVideo;
      this.videoRef.addEventListener(
        'ended',
        () => {
          this.setToolbarMode(this.hasScheduledActivity ? 'fullScreenOnly' : 'inActivity');

          this.onComplete();
        },
        false
      );
      this.videoRef.play();
    }
  },
  mixins: [AssetLoader]
};
</script>

<style lang="scss">
@import 'src/assets/sass/fade.scss';

.intro-container {
  background-position: center;
  background-size: cover;
  position: relative;
  height: 100%;
  width: 100%;

  .activity-title {
    font-size: 48px;
    margin-top: 60px;
    position: absolute;
    text-align: center;
    width: 100%;
  }

  #animation-video {
    position: absolute;
    height: auto;
    width: 100%;
    top: 0;
    z-index: 1000;
  }
}

.is-mobile-browser {
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  max-height: 100vh;
  max-width: 100vw;
}
</style>
